"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMustache = void 0;
function formatMustache(fmt, values) {
    return fmt.replace(/\{([^{}]+)\}/g, (_, key) => { var _a; return (_a = values[key]) !== null && _a !== void 0 ? _a : `{${key}}`; });
}
exports.formatMustache = formatMustache;
